import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Quote } from "lucide-react";
import { PageHero, CtaBand } from "@/components/Blocks";
import { Reveal } from "@/components/motion";
import { STORIES } from "@/data/content";

export default function ClientStories() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => {
      const el = document.querySelector(hash);
      if (el) window.__lenis ? window.__lenis.scrollTo(el, { offset: -100 }) : el.scrollIntoView();
    }, 400);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main data-testid="client-stories-page">
      <PageHero
        testId="client-stories-hero"
        eyebrow="Anonymised client stories"
        lines={["Real recoveries.", "Names withheld."]}
        intro="Every story is shared with consent and fully anonymised. Details that could identify a client have been removed."
      />
      <section className="bg-[#070A12] pb-24">
        <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12">
          {STORIES.map((s, i) => (
            <article key={s.id} id={s.id} data-testid={`story-article-${i + 1}`} className="grid lg:grid-cols-12 gap-10 py-20 border-t border-[#C5A059]/20">
              <div className="lg:col-span-4 lg:sticky lg:top-32 self-start">
                <span className="font-display text-[7rem] leading-none text-outline">0{i + 1}</span>
                <p className="eyebrow mt-4">{s.code}</p>
                <dl className="mt-6 space-y-4 text-sm">
                  <div className="flex justify-between border-b border-white/10 pb-3"><dt className="text-slate-400">Profile</dt><dd className="text-slate-100">{s.profile}</dd></div>
                  <div className="flex justify-between border-b border-white/10 pb-3"><dt className="text-slate-400">Setting</dt><dd className="text-slate-100 text-right">{s.setting}</dd></div>
                </dl>
              </div>
              <div className="lg:col-span-8">
                <Reveal>
                  <h2 className="font-display text-3xl sm:text-5xl text-slate-50 leading-[1.1]">{s.title}</h2>
                </Reveal>
                <Reveal delay={0.1}>
                  <blockquote className="mt-10 pl-6 border-l border-[#C5A059] font-display italic text-2xl sm:text-3xl text-[#E2C68C] leading-snug">
                    <Quote className="w-6 h-6 mb-3 text-[#C5A059]/70" />
                    {s.quote}
                  </blockquote>
                </Reveal>
                <div className="mt-10 space-y-6 max-w-2xl">
                  {s.body.map((p, k) => (
                    <Reveal key={k} delay={0.05 * k}>
                      <p className="text-slate-300 leading-relaxed text-sm sm:text-base">{p}</p>
                    </Reveal>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
      <CtaBand />
    </main>
  );
}
